import { Injectable } from '@angular/core';
import { HttpService } from 'services/http/http.service';
import { ShowIfHttpError } from '@certemy/common';
import { ResendInviteData } from 'components/modal-windows/step-details/log-details/modal-content/invitation/invitation.component';

@Injectable()
export class ProfessionalLogService {
  private _draftSuperviserData;
  get draftSuperviserData() {
    return this._draftSuperviserData;
  }

  set draftSuperviserData(data) {
    this._draftSuperviserData = data;
  }

  constructor(private http: HttpService) {}

  @ShowIfHttpError('An error occurred while inviting supervisor. Please, try again later.')
  inviteSupervisor(data) {
    return this.http.post('/certification_step_instance/log/invite', data);
  }

  @ShowIfHttpError('An error occurred while resending the invitation to supervisor. Please, try again later.')
  resendInviteSupervisor(invitationId, data: ResendInviteData) {
    return this.http.post(`/invitation/${invitationId}/resend`, data);
  }
}
